<template>
  <div class="header">
    <div class="header__holder">
      <div class="header__item header__item--control header__item--menu">
        <div class="header__item-subwrapper header__item-subwrapper--mobile">
          <div class="header-burger" @click.stop.prevent="onBurgerClick" :class="{ isOpened: (isAsideActive || isAside2Active) }">
            <div class="stripe stripe--1" />
            <div class="stripe stripe--2" />
            <div class="stripe stripe--3" />
          </div>
        </div>
      </div>
      <div class="header__item header__item--logo">
        <router-link to="/" @click.native="closeMenus">
          <svg-use :basic="true" name="logo" class="header-logo" />
        </router-link>
      </div>
      <div class="header__item header__item--control">
        <div class="header__item-subwrapper header__item-subwrapper--desktop">
          <UiTextButton
            to="/products"
            variant="text-small"
            active-class="header__route-active"
            class="header__item-subwrapper-link"
            @click.native="closeMenus"
          >
            Продукция
          </UiTextButton>
          <UiTextButton
            to="/projects"
            variant="text-small"
            active-class="header__route-active"
            class="header__item-subwrapper-link"
            @click.native="closeMenus"
            onclick="ym(88776155, 'reachGoal', 'Click_projects')"
          >
            Реализовано
          </UiTextButton>
          <UiTextButton
            to="/application"
            variant="text-small"
            active-class="header__route-active"
            class="header__item-subwrapper-link"
            @click.native="closeMenus"
          >
            Оставить заявку
          </UiTextButton>
          <!-- <a
            href="#showrooms"
            class="header__item-subwrapper-link"
            v-if="currentRouteName === 'home'"
          >
            <span class="header__item-name">ШОУРУМЫ</span>
          </a> -->
          <UiTextButton
            to="/contacts"
            variant="text-small"
            active-class="header__route-active"
            class="header__item-subwrapper-link"
            @click.native="closeMenus"
            onclick="ym(88776155,'reachGoal','click_contacts'); return true;"
          >
            Шоурумы
          </UiTextButton>
        </div>
        <!-- <div class="header__item-subwrapper header__item-subwrapper--mobile">
          <button
            v-if="isAsideActive"
            @click="toggleAside"
            class="header-control header-control--aside"
          >
            <svg-use basic name="ic-aside-close" />
          </button>
          <div class="ic-catalog" v-else>
            <router-link to="/catalog">
              <svg-use basic name="ic-catalog"/>
            </router-link>
          </div>
        </div> -->
        <div class="header__item header__item--control header__item--menu" v-show="!isAside2Active">
          <div class="header__item-subwrapper header__item-subwrapper--mobile">
            <div class="header-burger-contact" @click.stop.prevent="openAside2">
              <svg-use :basic="true" name="aside-whatsapp" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgUse from './SvgUse.vue'
import { UiTextButton } from '@/components/common/ui'

export default {
  name: 'Header',

  components: { SvgUse, UiTextButton },

  computed: {
    isAsideActive () {
      return this.$store.getters['ui/aside'].active
    },
    isAside2Active () {
      return this.$store.getters['ui/aside2'].active
    },
    currentRouteName () {
      return this.$route.name
    }
  },

  methods: {
    closeMenus () {
      if (this.isAside2Active) this.$store.commit('ui/toggleAside2', false)
      if (this.isAsideActive) this.$store.commit('ui/toggleAside', false)
    },
    onBurgerClick () {
      if (this.isAside2Active) {
        this.$store.commit('ui/toggleAside2', false)
      } else {
        this.$store.commit('ui/toggleAside')
      }
    },
    openAside2 () {
      if (this.isAsideActive) this.$store.commit('ui/toggleAside', false)
      this.$store.commit('ui/toggleAside2', true)
    }
  }
}
</script>

<style lang="scss">
.header {
  padding-left: vw(100);
  padding-right: vw(100);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  width: 100vw;
  box-sizing: border-box;
  transition: padding 0.5s ease-out 0s;
  right: 0;
  background: #fff;
  height: $header-height;
  // box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.03);

  &::after {
    content: '';
    position: absolute;
    left: $aside-width;
    right: 0;
    bottom: 0;
    height: 6px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.03);

    @include max-width(mobile) {
      left: 0;
    }
  }

  @include max-width(tablet) {
    padding-bottom: 0;
    box-sizing: border-box;
  }

  @include max-width(mobile) {
    height: $header-mob;
    padding-left: vw-m(27);
    padding-right: vw-m(27);
    z-index: 11;
  }

  &__holder {
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }

  &__item {
    &--logo {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
    }

    &-temp {
      display: none;

      @include max-width(mobile) {
        display: block;
        font-size: vw-m(19);
        margin-top: vw-m(-20);
      }
    }

    &--menu {
      @include max-width(mobile) {
        order: 1;
      }
    }

    &-subwrapper {
      &--mobile {
        cursor: pointer;

        @include max-width(mobile) {
          font-size: 0;
        }

        .header-control--aside {
          @include button;

          @include max-width(mobile) {
            font-size: 0;
            height: vw-m(34);
          }

          .ic-svg {
            width: vw(22);
            height: vw(22);

            @include max-width(mobile) {
              width: vw-m(34);
              height: vw-m(34);
            }
          }
        }

        .ic-catalog {
          width: vw(22);
          height: vw(22);

          @include max-width(mobile) {
            width: vw-m(30);
            height: vw-m(30);
          }
        }

        .ic-catalog .ic-svg {
          width: vw(22);
          height: vw(22);
          opacity: 0.45;

          @include max-width(mobile) {
            width: vw-m(30);
            height: vw-m(30);
          }
        }

        .header__item-list {
          position: absolute;
          top: 0;
          left: 0;
        }

        .header-control--aside {
          @include min-width(mobile) {
            display: none;
          }
        }

        .header__item-lang {
          display: none;

          &--active {
            display: list-item;
          }

          &:not(:last-child) {
            margin-right: 0;
          }

          &-block {
            width: vw(22);
            height: vw(19);
            position: relative;

            &::after {
              content: "";
              position: absolute;
              top: vw(5);
              right: vw(-24);
              width: vw(14);
              height: vw(8);
              transition: transform 0.3s ease 0s;
              background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDIgNzkuMTYwOTI0LCAyMDE3LzA3LzEzLTAxOjA2OjM5ICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+nhxg7wAAAGxJREFUGJWNz7ENg0AMBdB3oksTiVFoMgJD0NGxQdrQZYH0GYENWCoFBSHNIUURlztL7vy+7YAGtfJaMcMFL2wF/Ub/ndJiKYDXoxO6mJhC93/3Dwn0RMg9f/tBE6oc2usR0YxTKRI3jDinBj6F5iw9Hm8zqQAAAABJRU5ErkJggg==");
            }

            &.is-open::after {
              transform: rotate(180deg);
            }

            &.is-open {
              .header__item-lang {
                display: list-item;
                opacity: 0.55;

                &--active {
                  opacity: 1;
                }
              }
            }
          }
        }

        @include min-width(mobile) {
          display: none;
        }
      }

      &--desktop {
        display: flex;
        cursor: pointer;

        @include max-width(sm) {
          display: none;
        }

        .ic-svg {
          margin-left: vw(6);
          width: vw(16);
          height: vw(16);
          stroke: currentColor;
          fill: currentColor;
          color: #999;
          transition: color 0.3s ease-out;
        }
      }

      &-link {
        margin-left: vw(32);
      }
    }
  }

  &-logo {
    display: block;
    width: vw(128);
    height: vw(32);

    @include max-width(mobile) {
      width: vwm(80);
      height: vwm(18);
    }
  }

  &-burger {
    width: vw(22);
    height: vw(14);
    position: relative;
    transition: transform 0.3s ease 0s;
    @include max-width(mobile) {
      width: vwm(22);
      height: vwm(14);
    }
    &-contact {
      svg {
        width: vw(32);
        height: vw(32);
        @include max-width(mobile) {
          width: vwm(32);
          height: vwm(32);
        }
      }
    }
  }

  .stripe {
    width: vw(22);
    height: vw(2);
    background-color: #2c2c2c;
    position: absolute;
    left: 0;
    right: 0;
    transition: opacity 0.15s linear 0s, transform 0.3s ease 0s,
      width 0.3s ease 0s, margin 0.3s ease 0s;
    @include max-width(mobile) {
      width: vwm(22);
      height: vwm(2);
    }
    &--1 {
      top: 0;
      transform-origin: top left;
    }

    &--2 {
      top: vw(6);
      @include max-width(mobile) {
        top: vwm(6);
      }
    }

    &--3 {
      bottom: 0;
      transform-origin: bottom left;
    }
  }

  .isOpened {
    .stripe {
      width: vw(17.8);
      @include max-width(mobile) {
        width: vwm(17.8);
      }

      &--1 {
        transform: rotate(45deg);
      }

      &--2 {
        opacity: 0;
      }

      &--3 {
        transform: rotate(-45deg);
      }
    }
  }
}</style>
